<template>
    <a-popconfirm
        title="确认切换吗?"
        :get-popup-container="getPopupContainer"
        @confirm="onConfirm(!checked)"
    >
        <a-switch :checked="checked" :loading="loading"/>
    </a-popconfirm>
</template>

<script>
import {ref, computed} from "vue";
import {message} from "ant-design-vue";
import {postAction,postJson} from "@/utils/http/service";

export default {
    name: "SwitchBtn",
    props: {
        value: {
            type: [String, Number],
        },
        checkedValue: {
            type: [String, Number],
            default: 1,
        },
        uncheckedValue: {
            type: [String, Number],
            default: 0,
        },
        switchUrl: {
            type: String,
            default: "",
        },
        keyField: {
            type: String,
            default: "id",
        },
        params: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    setup(props, {emit}) {
        const checked = computed(() => props.value === props.checkedValue);
        const loading = ref(false);
        const onConfirm = (checked) => {
            let value = checked ? props.checkedValue : props.uncheckedValue;
            if (props.switchUrl) {
                loading.value = true;
                if(props.params.submitType == 'json'){
                    postJson({
                    url: props.switchUrl,
                    params: {
                        [props.keyField]: value,
                        ...props.params,
                    },
                    returnMsg: true,
                })
                    .then((res) => {
                        loading.value = false;
                        message.success(res.msg || "切换成功");
                        emit("ok");
                    })
                    .catch(() => {
                        loading.value = false;
                    });
                }else{
                    postAction({
                    url: props.switchUrl,
                    params: {
                        [props.keyField]: value,
                        ...props.params,
                    },
                    returnMsg: true,
                })
                    .then((res) => {
                        loading.value = false;
                        message.success(res.msg || "切换成功");
                        emit("ok");
                    })
                    .catch(() => {
                        loading.value = false;
                    });
                }
                
            } else {
                message.warning("请先设置switchUrl");
            }
        };
        return {
            checked,
            loading,
            onConfirm,
        };
    },
};
</script>

<style scoped>
</style>
